import React from 'react';
import IctOnboardingForm from '../../components/forms/users/IctOnboardingForm';

const IctOnboardingContainer = () => {
  return (
    <div>
      Onboarding
      <IctOnboardingForm />
    </div>
  );
};

export default IctOnboardingContainer;
